import { CommentLike } from "./comment-like";

export class Comment {
    id:string | undefined;
    userId:string | undefined;
    rootId:string | undefined;
    commentId:string | undefined;
    text:string|undefined;
    status:boolean | undefined;
    createDate: Date | undefined;
    lang:string | undefined;
    country:string | undefined;
    commentCount:number=0
    likeOn:number=0;
    likeOff:number=0;
        
    commentlike:CommentLike | undefined;
    commentVisible:Boolean=false;
    likeNew:number | undefined;
    constructor(
        ) {
        }
}
